import { Game } from '../../games.model';
import { SectionConfig, TileRowCollection as TileRowCollectionType } from '../../GameCard/GameCard.types';
import { getRequiredGameCount } from '../../../../utils/games/createTileRowCollections';

export interface CollectionValidationProps {
  collectionsWithContent: TileRowCollectionType[];
  findGameById: (id: string) => Game | undefined;
}

export const validateCollectionHasContent = (
  collection: TileRowCollectionType,
  findGameById: (id: string) => Game | undefined
): boolean => {
  const sections = [
    collection.half_width_tile,
    collection.first_full_width_tile,
    collection.second_full_width_tile,
    collection.third_full_width_tile_block,
  ].filter(Boolean) as SectionConfig[];

  const hasContent = sections.some((section) => {
    const requiredCount = getRequiredGameCount(section.type);
    const availableCount =
      section.games?.reduce((count, gameId) => {
        const matchingGame = findGameById(gameId);

        return count + (matchingGame ? 1 : 0);
      }, 0) ?? 0;

    const hasEnough = availableCount >= requiredCount;

    return hasEnough;
  });

  return hasContent;
};

export const filterCollectionsWithContent = (
  collections: TileRowCollectionType[],
  findGameById: (id: string) => Game | undefined
): TileRowCollectionType[] => {
  return collections.filter((collection) => validateCollectionHasContent(collection, findGameById));
};

export const createGamesById = (games: Game[]): Map<string, Game> => {
  const gameMap = new Map<string, Game>();

  games.forEach((game) => {
    const uniqueKey = game.id || game.gameId;

    gameMap.set(uniqueKey, game);
  });

  return gameMap;
};

export const createGameFinder = (gamesById: Map<string, Game>) => {
  return (id: string): Game | undefined => gamesById.get(id);
};
